import { DownloadIcon } from "assets/icons";
import { If } from "components";
import { useSearchParameter } from "hooks";
import {
  useOrdersList,
  OrdersTable,
  OrderModal,
  useOrdersDetailsByIds,
  downloadOrderPdf
} from "modules/orders";
import { QRCodeCanvas } from "qrcode.react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Button, Pagination, SearchInput } from "ui";

import styles from "./ResellerOrders.module.scss";

const ResellerOrders = () => {
  const { t } = useTranslation();

  const {
    mutateAsync: getOrdersDetailsByIds,
    isLoading: isOrdersForDownloadLoading
  } = useOrdersDetailsByIds();

  const {
    orders,
    isLoading,
    searchValue,
    setSearchValue,
    sorting,
    setSorting,
    page,
    totalItems,
    setPage,
    refetchOrders
  } = useOrdersList();

  const [openedOrderId, setOpenedOrderId] = useSearchParameter("orderId");
  const [selectedOrdersIds, setSelectedOrdersIds] = useState<string[]>([]);

  return (
    <div className={styles.resellerOrders}>
      <div className={styles.resellerOrders_header}>
        <SearchInput
          value={searchValue}
          onChange={setSearchValue}
          placeholder="Search..."
        />

        {selectedOrdersIds.length !== 0 && (
          <>
            <Button
              type="button"
              className={styles.downloadButton}
              title={`${t("Download QR & Details Sheet")} (${selectedOrdersIds.length})`}
              icon={<DownloadIcon width={24} height={24} />}
              variant="default"
              loading={isOrdersForDownloadLoading}
              onClick={async () => {
                const orderDetailsForDownload =
                  await getOrdersDetailsByIds(selectedOrdersIds);

                downloadOrderPdf(orderDetailsForDownload);
              }}
            />

            {selectedOrdersIds.map((orderId) => (
              <QRCodeCanvas
                key={orderId}
                value={orderId}
                id={`qr-${orderId}`}
                style={{ display: "none" }}
              />
            ))}
          </>
        )}
      </div>

      <div className={styles.resellerOrders_table}>
        <OrdersTable
          ordersList={orders ?? []}
          sorting={sorting}
          setSorting={setSorting}
          isLoading={isLoading}
          refetch={refetchOrders}
          oneResellerMode
          selectedOrdersIds={selectedOrdersIds}
          setSelectedOrdersIds={setSelectedOrdersIds}
        />
      </div>

      <Pagination
        currentPage={page}
        onChange={setPage}
        totalItems={totalItems}
      />

      <If condition={openedOrderId}>
        <OrderModal
          orderId={String(openedOrderId)}
          isOpen={Boolean(openedOrderId)}
          onClose={() => setOpenedOrderId(null)}
          refetchOrders={refetchOrders}
        />
      </If>
    </div>
  );
};

export default ResellerOrders;
